export enum ScheduleOrientationStatusEnum {
    PendingCandidateAvailability = 1,
    ActionRequiredScheduleOrientation = 2,
    PendingCandidateConfirmation = 3,
    CandidateConfirmedOrientation = 4,
    Cancelled = 5,
    ActionRequiredAskCandidateAvailability = 6
}
